import GestaoAVistaContext from '../../../../contexts/import/gestao-a-vista/GestaoAVistaContext';
import QCXPageTemplate from '../../../../templates/page/QCXPageTemplate';

export default function GestaoAVistaPage({ children }) {
  return (
    <GestaoAVistaContext.Provider value={{}}>
      <QCXPageTemplate contextComponent={GestaoAVistaContext}>{children}</QCXPageTemplate>
    </GestaoAVistaContext.Provider>
  );
}
